import { Result } from "@pacote/result"
import { v4 as uuidV4 } from "uuid"

import { getConfigParams } from "@/lib/get-config-params"
import useRequestIdStore from "@/store/request-id-store"
import useSignupRequestStore from "@/store/signup-request-store"

import {
  createFetcher,
  FetcherArgs,
  FetcherErrorResponse,
} from "./create-fetcher"

/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/

type DefaultData = {
  channel: number
  requestId: string
}

/* -------------------------------------------------------------------------------------------------
 * utils
 * -----------------------------------------------------------------------------------------------*/

const addDefaults = (arg: FetcherArgs, data: Record<string, any> = {}) => {
  const { channel } = getConfigParams()
  const { sessionId } = useSignupRequestStore.getState().data
  const endpoint = arg.url
  const verbAllowingRequestBody = isVerbAllowingRequestBody(arg.method)
  const hasRequestIdInStore = useRequestIdStore.getState().data[endpoint]
  const shouldEnrichHeaders = arg.enrichHeaders
  const requestId =
    hasRequestIdInStore && !verbAllowingRequestBody
      ? hasRequestIdInStore
      : uuidV4()

  if (!hasRequestIdInStore || verbAllowingRequestBody) {
    useRequestIdStore.getState().setData({ [endpoint]: requestId })
  }

  const defaultData: DefaultData = {
    channel,
    requestId,
  }

  const defaultHeaders = shouldEnrichHeaders
    ? {
        "x-channel-id": defaultData.channel.toString(),
        "x-call-id": defaultData.requestId,
        "x-session-id": sessionId,
      }
    : {}

  return [
    {
      ...(shouldEnrichHeaders ? {} : defaultData),
      ...data,
    },
    defaultHeaders,
  ] as const
}

const isVerbAllowingRequestBody = (verb?: string) => {
  return verb != null && ["POST", "PUT", "PATCH"].includes(verb)
}

/* -------------------------------------------------------------------------------------------------
 * fetchers
 * -----------------------------------------------------------------------------------------------*/

const fetchBaseQuery = createFetcher({
  baseUrl: typeof window !== "undefined" ? window.APP_API_URL : "",
  //TODO --> DA DECOMMENTARE UNA VOLTA CHE NON DOVREMO PIÙ MANDARE LE ROBBE ANCHE IN QP/BODY
  // prepareHeaders(headers, options) {
  //   const { channel } = getConfigParams()

  //   headers.append("x-channel-id", channel)
  //   headers.append("x-call-id", uuidV4())
  //   headers.append("x-session-id", sessionId)

  //   return headers
  // },
})

//TODO --> È BRUTTO COME LA MORTE MA UNA VOLTA CHE AVRANNO ALLINEATO ANCHE ITA CANCELLEREMO TUTTO E METTEREMO I DEFAULTS NEGLI HEADERS
const baseClientFetcher = <S, E>(
  arg: FetcherArgs,
): Promise<Result<S, FetcherErrorResponse<E>>> => {
  if (isVerbAllowingRequestBody(arg.method)) {
    const [body, headersFromBody] = addDefaults(arg, arg.body || {})
    arg.body = body
    arg.headers = { ...headersFromBody, ...arg.headers }

    return fetchBaseQuery(arg)
  }

  const [params, headersFromParams] = addDefaults(arg, arg.params || {})

  arg.params = params
  arg.headers = { ...headersFromParams, ...arg.headers }
  return fetchBaseQuery(arg)
}

const baseExternalFetcher = createFetcher({})

export { baseClientFetcher, baseExternalFetcher }
